import { Alert, AlertTitle } from "@material-ui/lab";
import { hasAnyAuthority } from "app/shared/auth/private-route";
import { AUTHORITIES } from "app/shared/config/constants";
import { IRootState } from "app/shared/reducers";
import  * as React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import ButtonAppBar from "../Navbar/ResponsiveAppBar";

import "./header.css"

export interface ISpbHeader {
  bgImage?: string;
  visible?: boolean;
  rulesDataResponse? : any;
  sidNavData?:any;
  DesktopType?: any;
}

export const SpbHeader:React.FC<ISpbHeader> = ({ visible, bgImage, rulesDataResponse,sidNavData,DesktopType }):JSX.Element => {
 
  const navBarItem = rulesDataResponse?.composeApp?.HEADER;
  if (!visible || !bgImage) return null
  else {
    const imgUrl = "url("+bgImage+")";
    return (
     <> <div className="header">
        {/* <img src="/content/images/Logo-spb.png" alt="" /> */}

        <ButtonAppBar router={navBarItem} cmsNavBar={sidNavData} DesktopType={DesktopType}/>
        </div>
    </>

    );
  }
};
